<template>
  <div>
    <div
      class="my-border-radius-top"
      :class="isDarkSkin ? 'bg-calendar-dark' : 'bg-calendar'"
    >
      <div class="d-flex justify-content-between pt-2 mx-2">
        <div class="d-flex align-items-center">
          <feather-icon
            icon="ChevronLeftIcon"
            size="35"
            class="cursor-pointer text-primary"
            v-b-tooltip.hover
            @click="previousMonth"
            :title="$t('previous month') | capitalize"
          ></feather-icon>
        </div>

        <div
          class="d-flex align-items-center text-uppercase h2 text-primary font-weight-bolder"
        >
          {{ getNameOfMonth(currentMonth) | capitalize }} - {{ currentYear }}
        </div>

        <div class="d-flex align-items-center">
          <feather-icon
            @click="nextMonth"
            icon="ChevronRightIcon"
            size="35"
            class="cursor-pointer text-primary"
            v-b-tooltip.hover
            :title="$t('next month') | capitalize"
          ></feather-icon>
        </div>
      </div>
      <div class="container-selects">
        <div>
          <v-select
            id="type"
            label="text"
            :options="months"
            :reduce="(val) => val.value"
            v-model="currentMonth"
            :clearable="false"
            class="select-width"
          />
        </div>
        <div class="ml-1">
          <v-select
            v-model="currentYear"
            class="select-width-year"
            :options="years"
            :clearable="false"
          ></v-select>
        </div>
      </div>
    </div>
    <div
      class="calendar py-2 my-border-radius-bottom container-padding"
      :class="isDarkSkin ? 'bg-calendar-dark' : 'bg-calendar'"
    >
      <div
        v-for="(name, index) in namesDay"
        class="calendar-header text-center border-left border-right text-white"
        :key="index + name"
      >
        {{ $t(name) }}
      </div>
      <div
        v-for="(day, index) in dayLastMonth"
        :key="index + '_last'"
        :class="
          isDarkSkin ? 'my-border-dark bg-last-dark' : 'my-border-2 bg-last'
        "
      ></div>
      <div
        v-for="(day, index) in attendance"
        class="day font-weight-bolder"
        :key="index"
        :class="isDarkSkin ? 'my-border-dark' : 'my-border-2'"
      >
        <b-badge
          :variant="variantStatus(day)"
          class="d-flex align-items-center justify-content-center my-badge"
        >
          <div>
            <div class="day-font">
              {{ day.date | myNumberDay }}
              <feather-icon
                style="position: absolute; right: 10%"
                v-if="day.is_late"
                class="text-warning"
                icon="AlertCircleIcon"
                v-b-tooltip.hover
                :title="$t('LATE')"
              ></feather-icon>
            </div>
            <div style="margin-top: 7px">
              {{ textStatus(day) }}
            </div>
          </div>
        </b-badge>
        <div style="position: relative" class="cursor-pointer">
          <div
            v-if="day.date === currentDate"
            class="current-day text-success"
            :style="markTodayPostion"
          >
            <feather-icon icon="CalendarIcon" :size="iconMapSize" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
import moment from "moment";
import AttendanceUtils from "@/views/attendance/views/my-attendance/utils/utils.js";
import AttendanceService from "@/views/attendance/services/attendance.service.js";
export default {
  name: "Calendar",

  computed: {
    ...mapGetters({
      windowWidth: "app/getWindowWidth",
      currentUser: "auth/currentUser",
    }),

    iconSize() {
      if (this.windowWidth < 300) {
        return 23;
      } else {
        return 30;
      }
    },

    iconMapSize() {
      if (this.windowWidth < 700) {
        return "18";
      }
      if (this.windowWidth < 600) {
        return "15";
      }
      if (this.windowWidth < 500) {
        return "12";
      }
      if (this.windowWidth < 300) {
        return "10";
      } else {
        return "25";
      }
    },

    markTodayPostion() {
      if (this.windowWidth > 900) {
        return {
          top: "-20px",
          right: "-50px",
        };
      }
      if (this.windowWidth > 800) {
        return {
          top: "-20px",
          right: "-40px",
        };
      }

      if (this.windowWidth > 700) {
        return {
          top: "-15px",
          right: "-30px",
        };
      }

      if (this.windowWidth > 500) {
        return {
          top: "-14px",
          right: "-30px",
        };
      } else {
        return {
          top: "-10px",
          right: "-20px",
          width: "15px",
          height: "15px",
        };
      }
    },

    months() {
      return [
        {
          value: 1,
          text: this.$options.filters.capitalize(this.$t("january")),
        },
        {
          value: 2,
          text: this.$options.filters.capitalize(this.$t("february")),
        },
        { value: 3, text: this.$options.filters.capitalize(this.$t("march")) },
        { value: 4, text: this.$options.filters.capitalize(this.$t("april")) },
        { value: 5, text: this.$options.filters.capitalize(this.$t("may")) },
        { value: 6, text: this.$options.filters.capitalize(this.$t("june")) },
        { value: 7, text: this.$options.filters.capitalize(this.$t("july")) },
        { value: 8, text: this.$options.filters.capitalize(this.$t("august")) },
        {
          value: 9,
          text: this.$options.filters.capitalize(this.$t("september")),
        },
        {
          value: 10,
          text: this.$options.filters.capitalize(this.$t("october")),
        },
        {
          value: 11,
          text: this.$options.filters.capitalize(this.$t("november")),
        },
        {
          value: 12,
          text: this.$options.filters.capitalize(this.$t("december")),
        },
      ];
    },
  },
  data() {
    return {
      showModalDetail: false,
      namesDay: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      currentDate: moment(new Date()).format("YYYY-MM-DD"),
      daysOfCurrentMonth: [],
      dayLastMonth: [],
      years: [],
      attendance: [],
      dataModal: {},
      holidays: [],
    };
  },

  methods: {
    getDaysOfMonth() {
      this.daysOfCurrentMonth = [];

      var firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
      var lastDay = new Date(this.currentYear, this.currentMonth - 1, 0);

      for (var day = firstDay.getDate(); day <= lastDay.getDate(); day++) {
        var currentDate = new Date(
          this.currentYear,
          this.currentMonth - 1,
          day
        );
        var daysOfMonth = {
          day: day,
          fullDate: moment(currentDate).format("YYYY-MM-DD"),
          key_date: moment(currentDate).format("MM-DD"),
        };
        this.daysOfCurrentMonth.push(daysOfMonth);
      }
    },
    async getAttendanceByEmployee() {
      try {
        this.addPreloader();
        var firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
        var fistDayNextMonth = new Date(this.currentYear, this.currentMonth, 1);
        let date = moment(firstDay).format("YYYY-MM-DD");
        let date_to = new Date(fistDayNextMonth.getTime() - 1);
        date_to = moment(date_to).format("YYYY-MM-DD");
        const params = {
          employee_id: this.currentUser.employee_id,
          date_from: date,
          date_to: date_to,
        };
        const data = await AttendanceService.getEmployeeAttendance(params);
        this.attendance = await AttendanceUtils.asingAttendace2Day(
          data.data,
          date,
          date_to,
          this.holidays
        );
        this.$emit("update", this.attendance);
      } catch (error) {
        console.log(error);
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },
    getDaysLastMonth() {
      this.dayLastMonth = [];

      var firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
      var dayWeek = firstDay.getDay();

      if (dayWeek === 0) {
        dayWeek = 7;
      }

      this.dayLastMonth = dayWeek - 1;
    },

    generateLastTenYears() {
      this.years = [];

      for (var i = this.currentYear - 5; i <= this.currentYear + 5; i++) {
        this.years.push(i);
      }
    },

    nextMonth() {
      if (this.currentMonth == 12) {
        this.currentMonth = 1;
      } else {
        this.currentMonth += 1;
      }
    },

    previousMonth() {
      if (this.currentMonth == 1) {
        this.currentMonth = 12;
      } else {
        this.currentMonth -= 1;
      }
    },
    async getHolidays() {
      // var firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
      // let date = moment(firstDay).format("YYYY-MM-DD");
      // const params = {
      //   date: date,
      // };
      // const data = await AttendanceService.getHolidays(params);
      // this.holidays = data.data;

      // const currentMonth = moment(this.dateFrom).format("MM");

      const params = {
        months: [this.currentMonth],
      };

      const data = await AttendanceService.getHolidays(params);
      this.holidays = data.data;
    },

    variantStatus(day) {
      if (!day.past_date) {
        return "light-secondary";
      }
      if (day.holidays) {
        return "light-info";
      }

      if (day.status == 3) {
        return "light-primary";
      }

      if (!day.start_hour) {
        return "light-danger";
      }

      switch (day.status) {
        case 1:
          if (day.is_late) {
            return "light-warning";
          } else {
            return "light-success";
          }
        case 2:
          return "light-secondary";
        case 3:
          return "light-primary";
        case 4:
          if (day.is_late) {
            return "light-warning";
          } else {
            return "light-success";
          }
      }
    },

    textStatus(day) {
      if (!day.past_date) {
        return this.$t("PENDING");
      }
      if (day.holidays) {
        return this.$t("HOLIDAY");
      }

      if (day.status == 3) {
        return this.$t("REMOTE");
      }

      if (!day.start_hour) {
        return this.$t("UNMARKED");
      }
      switch (day.status) {
        case 1:
          return day.start_hour + " - " + day.end_hour;
        case 2:
          return this.$t("NOT WORKING");
        case 3:
          return this.$t("REMOTE");
        case 4:
          return day.start_hour + " - " + day.end_hour;
      }
    },
  },

  created() {
    this.getHolidays();
    this.generateLastTenYears();
    this.getDaysLastMonth();
    this.getDaysOfMonth();
    this.getAttendanceByEmployee();
  },

  watch: {
    currentMonth(oldValue, newValue) {
      if (!newValue) {
        return;
      }

      this.getAttendanceByEmployee();
      this.getDaysLastMonth();
      this.getDaysOfMonth();
    },

    currentYear(oldValue, newValue) {
      if (!newValue) {
        return;
      }
      this.getHolidays();
      this.getAttendanceByEmployee();
      this.getDaysLastMonth();
      this.getDaysOfMonth();
    },
  },
};
</script>
  
  <style scoped lang="scss">
.container-selects {
  display: flex;
  justify-content: end;
  margin-top: 20px;
  margin-right: 20px;
}
.my-badge {
  height: 60px;
  width: 80%;
  white-space: normal;
  padding: 0 !important;
}
.my-border-radius-top {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.calendar-header {
  padding: 5px 0 5px 0;
  font-family: "Roboto";
  background-color: #34495e;
}

/* .last-month {
    border: 1px solid black;
  } */
.day {
  height: 70px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Roboto";
  font-weight: 400;
  font-size: 13px;
}

.select-width,
.select-width-year {
  min-width: 130px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

.day-font {
  font-size: 13px;
  position: relative;
}
.current-day {
  width: 20px;
  height: 20px;
  z-index: 9;
  border-radius: 50% 50% 50% 0%;
  animation: growup 1s ease-in-out infinite;
  position: absolute;
}
@keyframes growup {
  0% {
    transform: scale(1) translateY(0%);
  }
  50% {
    transform: scale(1) translateY(-50%);
  }
  100% {
    transform: scale(1) translateY(0%);
  }
}

@media (min-width: 601px) and (max-width: 1000px) {
  /* Estilos específicos para pantallas con un ancho máximo de 600px */
  .container-padding {
    padding: 0 20px;
  }

  .day-font {
    font-size: 12px;
  }

  .day {
    font-size: 11px;
  }
}

@media (max-width: 600px) {
  /* Estilos específicos para pantallas con un ancho máximo de 600px */
  .container-padding {
    padding: 0 5px;
  }

  .day-font {
    font-size: 10px;
  }

  .day {
    font-size: 8px;
  }

  .container-selects {
    justify-content: center;
    margin-right: 0;
  }

  .select-width-year {
    min-width: 100px;

    ::v-deep .vs__selected {
      width: 60px;
    }
  }

  .select-width {
    min-width: 100px;

    ::v-deep .vs__selected {
      width: 80px;
    }
  }
}
</style>